import React from 'react';

import arrow from 'assets/images/icons/arrowRight.png';
import { Button, Status, Heading } from 'components/Atoms';
import { ExpandInfo } from 'components/Molecules';
import { popeyesPrimaryColors } from 'styles';

import * as T from './interfaces';
import * as S from './styles';

export const PlaceItem = ({
  id,
  place,
  buttonFavoriteTextProps,
  buttonContainerInfoTextProps,
  buttonGPSTextProps,
  buttonSelectMenuTextProps,
  status,
  expandTextProps,
  isFavorite,
  currentDay,
  onClickFavorite,
  onClickInfo,
  onClickGPS,
  onClickSelectPin,
  onSelectStore,
  userIsLoggedIn,
  ...rest
}: T.IItemPros) => (
  <S.Item {...rest} id={id} data-testid={id}>
    {userIsLoggedIn && (
      <Button
        id={buttonFavoriteTextProps.id}
        title={buttonFavoriteTextProps.title}
        logEvent={
          buttonFavoriteTextProps.logEvent && buttonFavoriteTextProps.logEvent
        }
        variant="ghost"
        onClick={() => onClickFavorite(place?.bk_number)}
      >
        <S.Star isFavorite={isFavorite}>
          <div />
        </S.Star>
      </Button>
    )}
    <S.ContainerInfo>
      <Button
        id={buttonContainerInfoTextProps.id}
        title={buttonContainerInfoTextProps.title}
        logEvent={
          buttonContainerInfoTextProps.logEvent &&
          buttonContainerInfoTextProps.logEvent
        }
        variant="ghost"
        onClick={onClickInfo}
        noHeritage
      >
        <S.HeaderInfo>
          <Heading id={id} level={6}>
            {place.name}
          </Heading>
          <span>{place.distance}</span>
        </S.HeaderInfo>
        <S.PrimariesInfo statusStore={status.current}>
          <span>{place.floor}</span>
          <S.PointSeparator />
          <Status id={id} status={status.current}>
            {status.text}
          </Status>
          <S.PointSeparator />
          <span>{status.nextTime}</span>
        </S.PrimariesInfo>
      </Button>
      <ExpandInfo
        id={id}
        title={expandTextProps.title}
        description={expandTextProps.description}
      >
        <S.Address>{place.address}</S.Address>
        <S.OpenGps>
          <Button
            id={buttonGPSTextProps.id}
            title={buttonGPSTextProps.title}
            logEvent={
              buttonGPSTextProps.logEvent && buttonGPSTextProps.logEvent
            }
            variant="ghost"
            onClick={onClickGPS}
            margin="litleMargin"
          >
            Abrir no GPS
          </Button>
        </S.OpenGps>
        <S.OpeningHoursList>
          {place.openingHours.map(({ day, hours }) => (
            <li key={place.name + day}>
              {currentDay === day ? (
                <>
                  <span>
                    <strong>{day}</strong>
                  </span>
                  <span>
                    <strong>
                      {hours.open} - {hours.close}
                    </strong>
                  </span>
                </>
              ) : (
                <>
                  <span>{day}</span>
                  <span>
                    {hours.open} - {hours.close}
                  </span>
                </>
              )}
            </li>
          ))}
        </S.OpeningHoursList>
        <S.Advertence>
          Os horários de funcionamento ou
          <br />
          serviços podem mudar.
        </S.Advertence>
      </ExpandInfo>
    </S.ContainerInfo>
    <Button
      id={buttonSelectMenuTextProps.id}
      title={buttonSelectMenuTextProps.title}
      logEvent={
        buttonSelectMenuTextProps.logEvent && buttonSelectMenuTextProps.logEvent
      }
      variant="ghost"
      color={popeyesPrimaryColors.primary}
      onClick={() => onSelectStore(place.id, place.name)}
    >
      <img
        src={arrow}
        alt={`Seta indicando para ir até o cardápio do ${place.name}`}
      />
    </Button>
  </S.Item>
);
